import { Pie } from 'vue-chartjs/legacy'
import ChartDataLabels from 'chartjs-plugin-datalabels'
import chartjsMixin from '@/agilis/components/Chart/Chartjs/mixin/chartjsMixin'
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  ArcElement,
  CategoryScale
} from 'chart.js'

ChartJS.register(Title, Tooltip, Legend, ArcElement, CategoryScale, ChartDataLabels)
export default {
  name: 'ChartjsPie',
  components: {
    Pie
  },
  mixins: [chartjsMixin],
  props: {
    items: {
      type: [Object, Array]
    }
  },
  data () {
    return {
      chartOptions: {
        // added plugin to show labels on the graph
        plugins: {
          datalabels: {
            formatter: (value, ctx) => {
              let sum = 0
              let dataArr = ctx.chart.data.datasets[0].data
              dataArr.map(data => {
                sum += data
              })
              let percentage = (value * 100 / sum).toFixed(2) + '%'

              if (parseFloat(percentage) < 3.5) {
                return null // If the percentage is less than 4%, we hide the label, because it would be difficult to see
              } else {
                return percentage
              }
            },
            color: '#fff',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            offset: 10,
            padding: 5,
            align: 'end'
          }
        }
      }
    }
  },
  computed: {
    chartData () {
      const items = this.items
      const columns = Object.values(this.dashboardMetric.detail.dataTable.columns)
      const labelColConfig = columns[0]
      const valueColConfig = columns[1]
      const chart = {
        labels: [],
        datasets: [{
          backgroundColor: [],
          data: []
        }]
      }
      if (items) {
        items.forEach(item => {
          chart.labels.push(this.renderColumn(labelColConfig, item))
          chart.datasets[0].data.push(this.renderColumn(valueColConfig, item))
        })
        const dataLength = chart.datasets[0].data.length
        const backgroundColorsLength = this.dashboardMetric?.option?.backgroundColors.length
        let backgroundColors = this.dashboardMetric?.option?.backgroundColors
        if (backgroundColorsLength !== dataLength) {
          chart.datasets[0].backgroundColor = backgroundColors.concat(this.addColors(dataLength - backgroundColorsLength))
        } else {
          chart.datasets[0].backgroundColor = this.dashboardMetric?.option?.backgroundColors
        }
        chart.total = chart.datasets[0].data.reduce((acc, item) => acc + item, 0)
      }
      this.dashboardMetric.option.chartOptions.plugins = this.chartOptions.plugins
      // click on pie slice example
      this.dashboardMetric.option.chartOptions.onClick = this.handle
      return chart
    }
  },
  methods: {
    // click example
    handle (point, event) {
      const item = event[0]
      const a = {
        index: item.index,
        value: this.chartData.datasets[0].data[item.index]
      }
      console.log(a)
    }
  }
}
